<template>
    <div class="">
        <div class="custom-loader-wrapper" v-if="loader">
            <div class="text-center">
                <span class="d-block max-450">We are processing your download and this may take some.<br/>Do not close this window until the download begins.</span>
                <img v-bind:src="$api_url+'/public/images/download-loader.svg'" class="loader-logo" width="100px"/>
            </div>
        </div>
         <div class="col-sm-12  company-form-box-title row">
                <button v-on:click="viewDetails()" class="btn btn-primary position-static mr-3">Preview Report</span></button>
                <button v-on:click="getReport()" class="btn btn-primary position-static">Download</button>
        </div>
 
        
        <b-modal id="bv-modal-BSR" size="sm" hide-footer title="Yearly Payroll Report">
            <div>No data available for that date range!</div>
        </b-modal>  
        
        <b-modal id="balance-sheet-report" dialog-class="modal-lg" size="lg" scrollable  hide-footer title="Company Balance Sheet">
            <b-overlay  rounded="sm">
                <div class="text-center">
                <span class="d-block text-center">{{report_data.company_name}}</span>
                <span class="d-block text-center mb-3">{{report_data.title}}</span>
                </div>
                <table class="table"> 
                    <tbody>
                        <tr style="display: none;"></tr>
                        <tr class="table-row hover-bg">
                            <td>Property and assets</td>
                            <td>
                                <table class="table">
                                    <tr>
                                        <td class="2">Investments</td>
                                        <td class="2 text-right">{{formatMoney(details.investments)}}</td>
                                        
                                    </tr>
                                    <tr>
                                        <td class="2">Loan to members</td>
                                        <td class="2 text-right">{{formatMoney(details.loan_to_members)}}</td>
                                    </tr>
                                    <tr>
                                        <td class="2">Receivable from Employer</td>
                                        <td class="2 text-right">{{formatMoney(details.reecievable_from_employer)}}</td>
                                    </tr>
                                    <tr>
                                        <td class="2 font-wight-blod">Total property and assets</td>
                                        <td class="2 font-wight-blod text-right">{{formatMoney(details.total_property_and_assets)}}</td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                        <tr class="table-row hover-bg">
                            <td>Fund and liabilities</td>
                            <td>
                                 <table class="table">
                                    <tr>
                                        <td class="2">Employees' and employer's contribution</td>
                                        <td class="2 text-right">{{formatMoney(details.total_contribution)}}</td>
                                        
                                    </tr>
                                    <tr>
                                        <td class="2">Interest on contribution</td>
                                        <td class="2 text-right">{{formatMoney(details.interest_on_contribution)}}</td>
                                    </tr>
                                    <tr>
                                        <td class="2">Payable to outgoing members</td>
                                        <td class="2 text-right">{{formatMoney(details.payable_to_outgoing_members)}}</td>
                                    </tr>
                                     <tr>
                                        <td class="2">Balance in forfeture account</td>
                                        <td class="2 text-right">{{formatMoney(details.forfeiture_balance)}}</td>
                                    </tr>
                                    <tr>
                                        <td class="2 font-wight-blod">Total fund and liabilities</td>
                                        <td class="2 font-wight-blod text-right">{{formatMoney(details.total_fund_and_liabilities)}}</td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                        

                    </tbody>
                </table>
            </b-overlay>
        </b-modal>   
    </div>
</template>

<script>
    
    
    export default{
        
        mounted() {
            this.$refs.trzcalendar;
        },
        props: ['pageurl' , 'flag','leaver'],   
        components: {
            
        },     
        data(){
            
            return {
                 
                pageUrl:this.$api_url,
                
                search:'',
                length: 100,
                pagination: {currentPage: 1, pages:1},

                empty_result : 'Please hold tight! We are preparing the report data for you!',

                start_year : '',
                currentYear: new Date().getFullYear(),
                currentMonth:new Date().getMonth(),
                start_month: '',
                start_month_name: '',
                loader: false,
                showoverlay : true,
                
                payroll_reporting_data : [],
                details : [],
                report_data:[],

                months: [
                    { value: "1", text: "January" },
                    { value: "2", text: "February" },
                    { value: "3", text: "March" },
                    { value: "4", text: "April" },
                    { value: "5", text: "May" },
                    { value: "6", text: "June" },
                    { value: "7", text: "July" },
                    { value: "8", text: "August" },
                    { value: "9", text: "September" },
                    { value: "10", text: "October" },
                    { value: "11", text: "November" },
                    { value: "12", text: "December" },
                ],
                /***Ali */

                column_selected:[],
                column_options:[],
                default_fields:[],
                column_selected_view:[],
                show_selected:'',

                
            }
        },
        methods:{
            
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            getPayrollReporting: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/report/payrollreporting' , {
                    params: {
                        
                    }
                }).then(function(response){
                    this.payroll_reporting_data = response.data;
                    //console.log(this.payroll_reporting_data);
                    
                }.bind(this));
            },
            getReport: function()
            {
                if(!this.checkNet()) return false;
                this.loader = true;
                let url = ''
                
                url = this.$api_url + '/gf/balance-sheet-report';

                let formData = new FormData();
                formData.append('grid_report', 'Excel');
                formData.append('report', 1);
                let currentObj = this;
                axios.post(url, formData).then(function (response) 
                {
                    var fileURL = response.data; 
                    this.download_file(fileURL);
                    this.loader = false; 
                    
                }.bind(this))
                .catch(error => {
                    if(error.response){
                        this.$bvModal.show('bv-modal-YPR');
                        this.loader = false;
                    }
                });
                return false;
            },
            download_file(fileURL) 
            {
                if(!this.checkNet()) return false;
                
                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }    
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            replaceTableHeads(val){
                val = val.replace(/_/g, ' ');
                
                val = val.toLowerCase().split(' ');
                for(var i = 0; i < val.length; i++){
                    val[i] = val[i].charAt(0).toUpperCase() + val[i].substring(1);     
                }
                return val.join(' ');
            },
            viewDetails: function()
            {
                if(!this.checkNet()) return false;
                
                var months = ["", "January", "February", "March", "April", "May", "June", 
           "July", "August", "September", "October", "November", "December" ];
           

                let formData = new FormData();
                formData.append('viewmode', 1);
                formData.append('grid_report', 'Excel');
                formData.append('report', 1);
                let url = this.$api_url + '/gf/balance-sheet-report';
                
                let currentObj = this; 
                axios.post(url, formData).then(function (response) 
                {
                    var list_data = response.data;
                    this.report_data = list_data;
                    this.details = list_data.data;
                    this.loader = false;
                    
                }.bind(this))
                .catch(error => {
                    if(error.response){
                        this.$bvModal.show('bv-modal-BSR');
                        this.loader = false;
                    }
                });

            

                this.$bvModal.show('balance-sheet-report');

                
            },
            formatMoney: function(amount)
            {
                var money = Number(amount);
                money = money.toLocaleString();
                if(money=='NaN')
                money = amount;
                else{
                if(money.indexOf(".")<0)
                money = money+".00";
                }
                return money;
            },
            stringView(str) {
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            capitalizeTheFirstLetterOfEachWord(words) {
            var separateWord = words.toLowerCase().split(' ');
            for (var i = 0; i < separateWord.length; i++) {
                separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
                separateWord[i].substring(1);
            }
            return separateWord.join(' ');
            }

        },
        created: function(){
            this.start_year = this.currentYear;
            this.start_month = this.currentMonth + 1;
            this.getPayrollReporting();
        },
        computed: 
        {
            years () {
                const year = new Date().getFullYear();
                return Array.from({length: year - 2018}, (value, index) => year - index)
            },
            filteredData() 
            {
                let filtered_list = this.details;
                if (this.search) 
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }                
                return filtered_list;
            },
            paginatedData() 
            {     
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },
            
        }
    }
</script>

